<template>
  <section class="custom-wrapper">
    <ZTabs v-model="profileTab" :tabs="tabs" @change="showTab" @save="performSave" />
    <div class="row custom-row" v-if="profileTab === 'Overview'">
      <ProfileOverview ref="profileOverview" :firm="firm" @changed="changed" />
    </div>
    <div class="row custom-row" v-if="profileTab === 'Service Method'">
      <ServiceMethod ref="serviceMethod" :firm="firm" @changed="changed" />
    </div>
    <div class="row custom-row" v-if="profileTab === 'Service List'">
      <ServiceList ref="serviceList" :firm="firm" @changed="changed" />
    </div>
    <div class="row custom-row" v-if="profileTab === 'Training/Certificates'">
      <TrainingCertifications ref="trainingCertifications" :firm="firm" @changed="changed" />
    </div>
    <div class="row custom-row" v-if="profileTab === 'Reviews'">
      <Reviews ref="reviews" :firm="firm" />
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import ProfileOverview from './profiles/ProfileOverview.vue'
import ServiceMethod from './profiles/ServiceMethod.vue'
import ServiceList from './profiles/ServiceList.vue'
import TrainingCertifications from './profiles/TrainingCertifications.vue'
import Reviews from './profiles/Reviews.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
export default {
  name: 'location-profile',
  components: {
    ProfileOverview,
    ServiceMethod,
    ServiceList,
    TrainingCertifications,
    Reviews,
    ZTabs
  },
  props: {
    firm: Object
  },
  data() {
    return {
      isSave: false,
      profileTab: 'Overview',
      tabs: ['Overview', 'Service Method', 'Service List', 'Training/Certificates', 'Reviews']
    }
  },
  emits: ['changed', 'saved'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['profileData', 'location']),
    launchpadFirmId() {
      return this.location?.firmId || this.firm?.id
    }
  },
  methods: {
    ...mapActions(locationStore, ['getProfileData', 'getServiceMethodOptions', 'getServiceListOptions', 'getTrainingCertificationOptions', 'getAvailableInsurers']),
    showTab(value) {
      this.profileTab = value
    },
    changed() {
      this.isSave = true
      this.$emit('changed')
    },
    async getLists() {
      console.log('getLists in LocationProfile', { launchpadFirmId: this.launchpadFirmId })
      await this.getProfileData(this.launchpadFirmId)
      await this.getServiceMethodOptions()
      await this.getServiceListOptions()
      await this.getTrainingCertificationOptions()
      await this.getAvailableInsurers()
    },
    async performSave() {
      let response = {
        valid: false,
        msg: null
      }
      
      try {
        console.log('performSave called', { isSave: this.isSave, profileTab: this.profileTab })
        
        if (this.profileTab === 'Overview') {
          console.log('Saving Overview tab')
          await this.$refs.profileOverview.save()
        }
        if (this.profileTab === 'Service Method') {
          console.log('Saving Service Method tab')
          await this.$refs.serviceMethod.save()
        }
        if (this.profileTab === 'Service List') {
          console.log('Saving Service List tab')
          await this.$refs.serviceList.save()
        }
        if (this.profileTab === 'Training/Certificates') {
          console.log('Saving Training/Certificates tab')
          await this.$refs.trainingCertifications.save()
        }
        
        response.valid = true
        this.isSave = false
        this.$emit('saved')
        console.log('performSave completed successfully')
      } catch (error) {
        console.error('Error saving profile:', error)
        response.msg = 'Failed to save profile data'
      }
      
      return response
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  position: relative;
}
.custom-row {
  width: 100%;
  margin-left: 15px;
  margin-right: 25px;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
